/**
 * NIS2 Zelfscan — funnel-attributie van instappunt naar scan.
 *
 * Bewaart uitsluitend een gesloten whitelist van technische bronwaarden in
 * sessionStorage. Geen PII, geen cookies, geen third-party calls.
 * De waarde wordt als `entry_source` meegestuurd met bestaande scan-,
 * rapport- en advies-events.
 */

const STORAGE_KEY = 'nis2-entry-source-v1';

export const NIS2_ENTRY_SOURCES = [
  'nav',
  'footer',
  'home_hero',
  'home_seo_links',
  'nis2_it_partner',
  'nis2_checklist_mkb',
  'nis2_supply_chain',
  'nis2_aantoonbaarheid',
  'nis2_vragen_aan_msp',
  'direct_or_unknown',
] as const;

export type Nis2EntrySource = (typeof NIS2_ENTRY_SOURCES)[number];

export const NIS2_SCAN_PATH = '/nis2-zelfscan';

function isKnown(value: string | null): value is Nis2EntrySource {
  return !!value && (NIS2_ENTRY_SOURCES as readonly string[]).includes(value);
}

/** Sla het instappunt op. Latere clicks overschrijven (last-touch binnen de sessie). */
export function setNis2EntrySource(source: Nis2EntrySource): void {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.setItem(STORAGE_KEY, source);
  } catch {
    /* storage geblokkeerd — tracking degradeert naar direct_or_unknown */
  }
}

/** Huidig instappunt; altijd een geldige waarde, fallback `direct_or_unknown`. */
export function getNis2EntrySource(): Nis2EntrySource {
  if (typeof window === 'undefined') return 'direct_or_unknown';
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    return isKnown(raw) ? raw : 'direct_or_unknown';
  } catch {
    return 'direct_or_unknown';
  }
}

/**
 * Generieke hulp voor databasegestuurde nav-/footerlinks: legt alleen een bron
 * vast wanneer de link daadwerkelijk naar de zelfscan wijst.
 */
export function maybeSetNis2EntrySource(href: string, source: Nis2EntrySource): void {
  if (href === NIS2_SCAN_PATH) setNis2EntrySource(source);
}
